import { createContext, useContext, useState, ReactNode } from "react";

/**
 * Dashboard identity shown in the sidebar account control and related UI.
 *
 * `profilePicUrl` is optional — when absent the rail falls back to initials.
 */
export interface User {
  initials: string;
  name: string;
  email: string;
  color: string;
  /** Hosted profile photo URL, when the user has uploaded one. */
  profilePicUrl?: string;
}

// CRC Team members
export const CRC_TEAM: User[] = [
  { initials: 'PY', name: 'Percy Yeung', email: 'percy.yeung@asteracancer.com', color: '#3B82F6' },
  { initials: 'AL', name: 'Allison', email: 'allison@asteracancer.com', color: '#10B981' },
  { initials: 'CA', name: 'Carina', email: 'carina@asteracancer.com', color: '#F59E0B' },
  { initials: 'SH', name: 'Shreya', email: 'shreya@asteracancer.com', color: '#8B5CF6' },
];

interface UserContextType {
  currentUser: User;
  setCurrentUser: (user: User) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
  // Default to Percy Yeung
  const [currentUser, setCurrentUser] = useState<User>(CRC_TEAM[0]);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
